import React, { Component } from 'react'

import { FillerInlineDiv } from '../StyledComponents/Fillers'
import { SettingsInputNumber, SettingsTitle, SettingsRow } from '../StyledComponents/Settings'

class SettingsRowNumber extends Component {
    constructor(props) {
        super(props)

        this.onNumberChange = this.onNumberChange.bind(this)
    }

    onNumberChange(e) {
        this.props.handleChange(e.target.value)
    }

    render() {
        const {
            title,
            min,
            max,
            step,
            placeholder,
            currentValue,
        } = this.props

        const shownValue = currentValue <= 0 ? '' : currentValue

        return (
            <SettingsRow>
                <SettingsTitle className="align-top col-6">{title}</SettingsTitle>
                <FillerInlineDiv className="col-6 text-right">
                    <SettingsInputNumber value={shownValue} onChange={this.onNumberChange} placeholder={placeholder} type="number" step={step} min={min} max={max} />
                </FillerInlineDiv>
            </SettingsRow>
        )
    }
}

SettingsRowNumber.defaultProps = {
    min: 0,
    max: 120,
    step: 1,
    placeholder: 'in Minuten',
}

export default SettingsRowNumber



// WEBPACK FOOTER //
// ./src/components/Settings/SettingsRowNumber.js